export class KundorderMottagningsplatsTypeaheadRequestDTO   {

    input: string;
    kundordertyp: string;

    constructor() {
        this.input = undefined;
        this.kundordertyp = undefined;
    }
}
